import gql from 'graphql-tag';

export const ORGANIZATION_READONLY_QUERY = gql`
  query OrganizationReadOnly($orgName: String!) {
    organization(name: $orgName) {
      id
      orgEntity {
        id
        readOnly
      }
    }
  }
`;

export const PROJECT_READONLY_QUERY = gql`
  query ProjectReadOnly($entityName: String!, $projectName: String!) {
    entity(name: $entityName) {
      id
      project(name: $projectName) {
        id
        readOnly
      }
    }
  }
`;
